export default __webpack_public_path__ + "static/media/40f598b3c1416516fa79894dc1f89892.svg";